<template>
    <v-flex xs12 mb-4 pt-4 id="blocks">
        <v-toolbar text>
            <v-toolbar-title>Текстовые блоки</v-toolbar-title>
            <v-spacer/>
            <v-btn icon text>
                <v-switch v-model="textBlock.status"/>
            </v-btn>
        </v-toolbar>
        <v-layout flex wrap v-if="textBlock.status || textBlock.status === 'ACTIVE'">
            <v-flex xs4 v-for="(item, index) in textBlock.items" :key="item.id" class="carousel-item"
                    v-if="textBlock.items.length">
                <div @click="editTextBlock(index)" class="addCarousel">
                    <img :src="rootURL + item.img" alt="" class="carousel-img carousel-img--vertical"/>
                </div>
            </v-flex>
            <v-flex xs4 v-if="textBlock.items.length < 6" class="carousel-item">
                <div @click="dialogCreate = true" class="addCarousel">
                    <img src="/static/img/media/text_block_blank.svg" alt=""/>
                </div>
            </v-flex>
            <Add :on-close="closeDialog" :dialog-create="dialogCreate"/>
            <Edit :on-close="closeDialog" :dialog-edit="dialogEdit" :text-block="textBlockItem"/>
        </v-layout>
    </v-flex>
</template>

<script>
    import config from '../../../config'
    import Add from './Add'
    import Edit from './Edit'

    export default {
        name: 'siteTextBlock',
        components: {
            Add,
            Edit
        },
        props: ['textBlock', 'refreshTextBlock'],
        data: () => ({
            dialogCreate: false,
            dialogEdit: false,
            textBlockItem: {}
        }),
        created () {
            this.rootURL = config.rootPath
        },
        methods: {
            editTextBlock (index) {
                this.textBlockItem = this.textBlock.items[index]
                this.dialogEdit = true
            },
            closeDialog () {
                this.dialogCreate = false
                this.dialogEdit = false
                this.textBlockItem = {}
                this.refreshTextBlock()
            }
        }
    }
</script>
